import React from 'react';
import { FullSizeCenteredColumn } from '../../../Components/FlexBox';
import Stage from './Stage';
import getColorHeatByIndex from '../../Kanban/Utils/getColorHeatByIndex';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';

const Funnel = function Funnel({ stages, total }) {
  // Calculate funnel width based on index (gets progressively smaller)
  const calculateFunnelWidth = (
    index,
    totalStages,
    maxWidth = 1000,
    minWidth = 300
  ) => {
    if (totalStages <= 1) return maxWidth;

    // Calculate width reduction per stage
    const widthReduction = (maxWidth - minWidth) / (totalStages - 1);
    return maxWidth - widthReduction * index;
  };

  return (
    <FullSizeCenteredColumn alignItems="center" gap="16px" padding="24px">
      {stages?.map(({ id, name, customersCount, description }, index) => (
        <Stage
          key={id}
          title={capitalize(name)}
          value={customersCount || 0}
          color={getColorHeatByIndex(index, stages.length)}
          width={calculateFunnelWidth(index, stages.length)}
          percentageValue={
            customersCount ? Math.round((customersCount / total) * 100) : 0
          }
          description={description}
        />
      ))}
    </FullSizeCenteredColumn>
  );
};

export default Funnel;
